import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=307c207c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307c207c')) {
      api.createRecord('307c207c', component.options)
    } else {
      api.reload('307c207c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=307c207c&", function () {
      api.rerender('307c207c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sB2zUG35Vjz7/JS/comp/IncreaseNumber.vue"
export default component.exports